import { motion } from "framer-motion";
import { useState } from "react";

import { Button } from "@/components/ui/Button";
import { api } from "@/lib/api";

interface ConnectGSCProps {
  reason?: "not-connected" | "no-sites";
}

export function ConnectGSC({ reason = "not-connected" }: ConnectGSCProps) {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const startAuth = async () => {
    setBusy(true);
    setError(null);
    try {
      const { url } = await api.gsc.authStart();
      window.location.href = url;
    } catch (e) {
      setBusy(false);
      setError(e instanceof Error ? e.message : "failed to start auth");
    }
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 8 }}
      animate={{ opacity: 1, y: 0 }}
      className="surface p-12 text-center max-w-2xl mx-auto"
    >
      <div className="inline-flex items-center gap-2 mb-4">
        <span className="w-2 h-2 rounded-full bg-warn animate-pulse-led" />
        <span className="font-mono text-xs text-muted uppercase tracking-wider">
          {reason === "no-sites" ? "no verified properties" : "gsc not connected"}
        </span>
      </div>

      <h2 className="text-2xl font-semibold mb-3">El Portero</h2>
      <p className="text-muted mb-2 max-w-md mx-auto">
        Conectá Google Search Console para que el sistema solo genere artículos sobre
        búsquedas donde <em>Thinkler ya está a distancia de golpeo</em> — posición 11-30,
        impresiones altas, CTR bajo.
      </p>
      <p className="text-muted/70 text-sm mb-8 max-w-md mx-auto font-mono">
        No se escribe nada que Google no confirme que se busca.
      </p>

      <Button onClick={startAuth} variant="primary" disabled={busy}>
        {busy
          ? "…"
          : reason === "no-sites"
            ? "Reconnect GSC"
            : "Connect Google Search Console"}
      </Button>

      {error && (
        <p className="mt-4 font-mono text-xs text-danger" role="alert">
          {error}
        </p>
      )}

      <p className="text-xs text-muted/60 mt-6 font-mono">
        [read-only · webmasters.readonly scope · token guardado server-side]
      </p>
    </motion.div>
  );
}
